import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/gestionale/components/ui/alert-dialog";
import type { Tables } from "@/gestionale/integrations/supabase/types";

type Sponsor = Tables<"sponsors">;

interface DeleteSponsorDialogProps {
  sponsor: Sponsor | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export default function DeleteSponsorDialog({ sponsor, onOpenChange, onConfirm, isDeleting }: DeleteSponsorDialogProps) {
  return (
    <AlertDialog open={!!sponsor} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Eliminare questo sponsor?</AlertDialogTitle>
          <AlertDialogDescription>
            Stai per eliminare <strong>{sponsor?.name}</strong>. Lo sponsor sparirà anche dal sito pubblico. L'azione non è reversibile.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isDeleting} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
            {isDeleting ? "Eliminazione..." : "Elimina"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}